import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { cn } from 'utils/style'

import type { ButtonProps } from './types'

export const Button = ({
	children,
	icon,
	type = 'button',
	className,
	disabled = false,
	isLoading = false,
	styleType = 'primary',
	onClick
}: ButtonProps) => {
	return (
		<button
			type={type}
			className={cn(
				'relative rounded-lg px-9 py-1.5 text-white focus:outline-none',
				styleType === 'primary' && 'bg-accent',
				styleType === 'primary' && disabled && 'bg-spindle',
				styleType === 'cancel' && 'bg-fiord',
				styleType === 'delete' && 'bg-red',
				styleType === 'ghost' && 'border border-zinc-200 bg-zinc-100 text-black',
				styleType === 'outline' &&
					'border border-zinc-200 text-zinc-800 transition-colors hover:bg-zinc-100',
				icon && 'px-9',
				className
			)}
			disabled={disabled || isLoading}
			onClick={onClick}>
			<span className="flex items-center justify-center gap-2">
				{!isLoading ? (
					children
				) : (
					<FontAwesomeIcon className="min-w-16 animate-spin text-2xl" icon={faSpinner} />
				)}{' '}
				{icon && <FontAwesomeIcon className="absolute right-4" icon={icon} />}
			</span>
		</button>
	)
}
